const styles = (theme) => ({
  message: {
    padding: theme.spacing(5, 5),
    textTransform: 'capitalize',
    textAlign: 'center',
    fontSize: 20,
  },
});

export default styles;
